import type { Action } from '@ngrx/store';
import type { Attribute, AttributeId, UpdateRankAttributePayload } from '../../../interfaces/Attribute.interface';

export enum ActionType {
    RESET = '[RESET] RESET',
    FETCH_ATTRIBUTES = '[ATTRIBUTE] FETCH_ATTRIBUTES',
    FETCH_ATTRIBUTES_SUCCEEDED = '[ATTRIBUTE] FETCH_ATTRIBUTES_SUCCEEDED',
    FETCH_ATTRIBUTES_FAILED = '[ATTRIBUTE] FETCH_ATTRIBUTES_FAILED',
    ADD_ATTRIBUTE = '[ATTRIBUTE] ADD_ATTRIBUTE',
    UPDATE_ATTRIBUTE = '[ATTRIBUTE] UPDATE_ATTRIBUTE',
    DELETE_ATTRIBUTE = '[ATTRIBUTE] DELETE_ATTRIBUTE',
    UPDATE_RANK = '[ATTRIBUTE] UPDATE_RANK'
}

export class Reset implements Action {
    readonly type = ActionType.RESET;
}

export class FetchAttributes implements Action {
    readonly type = ActionType.FETCH_ATTRIBUTES;
}

export class FetchAttributesSucceeded implements Action {
    readonly type = ActionType.FETCH_ATTRIBUTES_SUCCEEDED;
    constructor(readonly payload: { attributes: Attribute[] }) {}
}

export class FetchAttributesFailed implements Action {
    readonly type = ActionType.FETCH_ATTRIBUTES_FAILED;
}

export class CreateAttribute implements Action {
    readonly type = ActionType.ADD_ATTRIBUTE;
    constructor(readonly payload: { attribute: Attribute }) {}
}

export class UpdateAttribute implements Action {
    readonly type = ActionType.UPDATE_ATTRIBUTE;
    constructor(
        readonly payload: {
            attributeId: AttributeId;
            attributeUpdate: Partial<Attribute>;
        }
    ) {}
}

export class DeleteAttribute implements Action {
    readonly type = ActionType.DELETE_ATTRIBUTE;
    constructor(
        readonly payload: {
            attributeId: AttributeId;
        }
    ) {}
}

export class UpdateRank implements Action {
    readonly type = ActionType.UPDATE_RANK;
    constructor(readonly payload: UpdateRankAttributePayload[]) {}
}

export type Actions =
    | Reset
    | FetchAttributes
    | FetchAttributesSucceeded
    | FetchAttributesFailed
    | CreateAttribute
    | UpdateAttribute
    | DeleteAttribute
    | UpdateRank;
